import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { CompressionService } from '../compression.service';
import * as shape from 'd3-shape';

@Component({
  selector: 'app-t-create-compression',
  templateUrl: './t-create-compression.component.html',
  styleUrls: ['./t-create-compression.component.css']
})
export class TCreateCompressionComponent extends GeneralTeacherComponent {

  mapping: any[][] = [["", ""], ["", ""], ["", ""], ["", ""]];

  get map0(): string[] {
    return this.mapping.map(v => v[0]);
  }

  get map1(): string[] {
    return this.mapping.map(v => v[1]);
  }

  greyOut: boolean = false;

  nodes: any[];
  edges: any[];

  view: any[] = undefined;
  fitContainer: boolean = true;
  curve = shape.curveBundle;

  constructor(topicService: TopicService, activatedRoute: ActivatedRoute, protected compressionService: CompressionService) {
    super(topicService, activatedRoute)
    this.title = this.get("createCompression");
    this.type = "createCompression";
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.mapping = this.configuration.typespecifics.mapping;
    this.greyOut = this.configuration.typespecifics.greyOut;
    let graph = this.compressionService.computeTreeBySize(this.mapping);
    this.nodes = graph.nodes;
    this.edges = graph.edges;
  }

  generateDefinition() {
    let definition: any = {};
    this.mapping.sort((a, b) => (+b[1] - +a[1]));
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/createCompression.png";
    definition.level = this.greyOut ? 1 : 2;
    definition.key = "compression%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.mapping = this.mapping;
    definition.typespecifics.greyOut = this.greyOut;
    definition.key = definition.key.concat("%", this.mapping.toString());

    return definition;
  }

  generate() {
    this.mapping = [];
    this.title = this.get("createCompression");
    let count = Math.floor(Math.random() * 4) + 4;
    let sum = 0;
    let alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    for (let i = 0; i < count; i++) {
      let char = alphabet.splice(Math.floor(Math.random() * alphabet.length), 1).toString();
      let frequency = Math.ceil((Math.random() * (100 - sum) - 5) / (count - this.mapping.length)) + 5;
      if (this.mapping.length == count - 1) {
        frequency = 100 - sum;
      }
      sum += frequency;
      this.mapping.push([char, frequency]);
    }

    this.mapping.sort((a, b) => (+b[1] - +a[1]));
    this.greyOut = (!this.isExam() && (Math.random() > 0.5));
    this.normalizeMapping(0);
  }

  reset() {
    super.reset();
    this.title = this.get("createCompression");
    this.mapping = [["", ""], ["", ""], ["", ""], ["", ""]];
    this.greyOut = false;
  }

  /** make sure the mapping only contains one letter, update the last computed frequency and update the graph */
  normalizeMapping(i: number) {
    this.mapping[i][0] = this.mapping[i][0].toUpperCase().replace(/[^A-Z]/gi, "").charAt(0);
    let sum = this.map1.slice(0, this.map1.length - 1).reduce((a, b) => + a + +b, 0);
    this.mapping[this.mapping.length - 1][1] = 100 - sum;
    if (this.map1.filter(v => v == undefined || v == "").length == 0) {
      let graph = this.compressionService.computeTreeBySize(this.mapping);
      this.nodes = graph.nodes;
      this.edges = graph.edges;
    }
  }

  /** remove the given letter, update the computed frequency and update the graph */
  deleteMapping(i: number) {
    this.mapping.splice(i, 1);
    this.normalizeMapping(0);
    if (this.map1.filter(v => v == undefined || v == "").length == 0) {
      let graph = this.compressionService.computeTreeBySize(this.mapping);
      this.nodes = graph.nodes;
      this.edges = graph.edges;
      console.log(this.nodes);
      console.log(this.edges);
    }
  }

  /** does every letter only occur once? */
  notUnique(): boolean {
    if (this.map0.filter((v, i) => this.map0.indexOf(v) != i).length > 0) {
      return true;
    }
    return false;
  }

  /** are all letters filled in? */
  notEnough(): boolean {
    if (this.map0.filter(v => v == undefined || v.trim() == "").length > 0) {
      return true;
    }
    return false;
  }

  /** is there any frequency smaller than 5? */
  smaller5(): boolean {
    return this.map1.filter(v => +v < 5).length != 0;
  }

}
